import { all, put, select, takeEvery, call } from 'redux-saga/effects';
import * as Actions from './actions';
import { find, get, isEmpty, isEqual, pick } from 'lodash';
import { modules } from 'veritone-redux-common';

import {
  saveMappingDataApi,
  getPlayoutOverviewApi,
  getPlayoutSettingApi,
  savePlayoutSettingApi,
  updateImportStatusApi,
  createAdapterJobApi,
  getSingedUriFromTDOId,
  assetPlayoutError,
  assetWebLogs,
  assetPlayoutLogs,
  assetWebError,
  runPlayoutUploadIngestion
} from '../../../../helpers/playoutUploaderApi';
import {
  getStationAvailabilityApi
} from '../../../../helpers/stationApi';
import { showToast } from '../notification';
import constants from '../../../../helpers/constant';
import {
  namespace as stationNamespace,
  Status as stationStatus,
  getStation
} from '../station/actions';
import { getStation as getStationSaga } from 'state/modules/app/station/saga';
import { actionReloadFilePicker, uploadRequest } from '../../../modules/filePicker';
import { getTDOIdFile } from '../../../../helpers/filePickerApi.js'
import { downloadFileApi} from '../../../../helpers/filePickerApi';
import { encodeBase64File } from '../../../../helpers/filePickerUtil';
import { getFileUriFromTdoApi } from '../../../../helpers/callGraphQLApi';
import { PLAYOUT_KEYS, WEB_KEYS, JOB_ROUTES, JOB_PREFIX, TDO_PREFIX } from './constant';
import { checkErrorStatusPlayoutApi, getJobStatusApi } from '../../../../helpers/jobApi'
import { PLAYOUT_IMPORT_STATUS } from '../../../../components/PlayoutUploadHistory/ImportStatus';
import { goToPlayoutUploadHistory } from '../../routing/actions';
import { DATE_RANGE_LIST_DEFAULT } from 'components/DatePicker/constants';
import { convertdateUTC, trimObjectValue } from '../../../../helpers/formatData';
import { PLAYOUT_DATA_TYPE, WEB_DATA_TYPE } from './constant';
import { STATUS_ENGINE } from 'components/PlayoutUploadHistory/constants.js';

const {
  config: { getConfig },
  user: { selectUser }
} = modules;

const DEFAULT_RANGE = DATE_RANGE_LIST_DEFAULT[4];

function* importLogWithUploadedFile(res, payload) {
  const config = yield select(getConfig);
  const { urlApi, playoutEngine = {}, attributeEngine = {} } = config;
  const { fileInfo = {}, uploadType } = payload;
  const dateNow = Date.now();
  const unsignedUrl = res[0].unsignedUrl;
  let TDOId;
  const assetType = uploadType === PLAYOUT_DATA_TYPE ? assetPlayoutLogs : assetWebLogs;

  // reset file picker 
  yield put(actionReloadFilePicker());
  
  const currentUser = yield select(selectUser);
  const organizationId = get(currentUser, 'organization.organizationId', '');
  const userEmail = get(currentUser, 'userName', ''); //login email of the uploader, used to send OPS alert email
  const currentUploadFile = yield select(state => get(state, [Actions.namespace, 'currentUploadFile', 'ref'], {}));
  const base64EncodedFileData = yield call(encodeBase64File, currentUploadFile);

  const featureFlags = yield select(state => get(state, ['featureFlagConfig', 'data'], []));
  const enablePlayoutIngestionAPIVer2 = get(featureFlags.find(item => item.configKey === 'enablePlayoutIngestionVer2'), 'value') === 'true';
  const {
    engineId,
    schemaId,
    clusterId: playoutClusterId,
    jobPriority: playoutJobPriority
  } = playoutEngine;

  const {
    engineId: webEngineId
  } = attributeEngine;

  const { name: fileName, size: fileSize } = currentUploadFile;
  const {
    firstEntryTime,
    lastEntryTime,
    timezone,
    recordCount,
    durationUnits,
    advertiserId,
    map: mappingInfo = {}
  } = fileInfo;
  const timeUnit = durationUnits === 'milliseconds' ? 'millisecond' : 'second';
  const timezoneKey = get(timezone, 'timezoneKey');
  
  //process mapping data, fill all missing keys
  const mappingKey = uploadType === PLAYOUT_DATA_TYPE ? PLAYOUT_KEYS : WEB_KEYS;
  const newMappingInfo = mappingKey.reduce((acc, item) => {
    acc[item] = mappingInfo[item] || '';
    return acc;
  }, {});

  let jobTasks = [], jobId;
  const isPlayoutUpload = uploadType === PLAYOUT_DATA_TYPE;
  if (isPlayoutUpload && enablePlayoutIngestionAPIVer2) {
    // call ingestion API
    const playoutIngestionData = {
      fileName,
      orgId: organizationId,
      logData: base64EncodedFileData,
      jobPayload: {
        mapping: trimObjectValue(newMappingInfo)
      },
      timeUnit
    }
    const playoutIngestionResult = yield runPlayoutUploadIngestion(urlApi, playoutIngestionData);
    jobId = get(playoutIngestionResult, 'jobId');
    TDOId = get(playoutIngestionResult, 'tdoId');
    if (playoutIngestionResult.error || !jobId|| !TDOId) {
      const errorToast = {
        message: playoutIngestionResult.error ? playoutIngestionResult.error.message : 'Save playout ingestion information failed',
        action: 'Dismiss',
        type: constants.FAILED
      };
      yield put(showToast(errorToast));
    }
  }
  else {
    //create TDO with uploaded file in unsignedUrl 
    if (unsignedUrl) {
      TDOId = yield getTDOIdFile(urlApi, unsignedUrl, dateNow, assetType);
    }
    if (!unsignedUrl || !TDOId) {
      const errorToast = {
        message: 'Saving file failed',
        action: 'Dismiss',
        type: constants.FAILED
      };
      yield put(Actions.getPlayoutOverview());
      return yield put(showToast(errorToast));
    }

    // structure job payload
    if(isPlayoutUpload){
      jobTasks.push({
        engineId,
        executionPreferences: {
          priority: playoutJobPriority
        },
        payload: {
          recordingId: TDOId,
          taskPayload: {
            schemaId,
            timezone: timezoneKey,
            organizationId,
            organizationToken: "",//organizationToken will only be used in email ingestion, for Attribute playout will use engine token from payload
            durationUnits,
            mapping: trimObjectValue(newMappingInfo),
            skipSDOIngestion: false,
            skipInvalidFile: true,
            isLogUploader: true, //job came from Log Uploader, not email ingestion
            fromEmail: userEmail, 
            fromEmailSubject: 'Playout Ingestion'
          }
        }
      })
    }
    else {
      jobTasks.push({
        engineId: webEngineId,
        executionPreferences: {
          priority: playoutJobPriority
        },
        payload: {
          taskPayload: {
            organizationId,
            advertiserId,
            tdoId: TDOId,
            delayInSecond: 0,
            mapping: trimObjectValue(newMappingInfo),
          }
        }
      })
    }

    // create job
    const createJobResult = yield createAdapterJobApi(urlApi, JOB_ROUTES, playoutClusterId, jobTasks);
    jobId = get(createJobResult, 'id');
    
    if (createJobResult.error || !jobId) {
      const errorToast = {
        message: 'Create job failed',
        action: 'Dismiss',
        type: constants.FAILED
      };
      yield put(Actions.getPlayoutOverview());
      return yield put(showToast(errorToast));
    }
  }

  //save import info to Attribute
  const dataImportPayload = {
    fileName,
    fileSize,
    firstEntryTime,
    lastEntryTime,
    timezone: timezoneKey,
    recordCount,
    durationUnits,
    jobId,
    map: newMappingInfo,
    fileReference: TDOId,
    fileType: uploadType,
    advertiserId,
    status: STATUS_ENGINE.PRE_PROCESS
  }
  const fetchResult = yield saveMappingDataApi(urlApi, dataImportPayload);
  if (fetchResult.error) {
    const errorToast = {
      message: 'Save data mapping info failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
  yield put(Actions.getPlayoutOverview());
}

function* importLogsWithDataMappingSaga(action) {
  const { id = null, fileInfo = {} } = action.payload;
  const playoutState = yield select(state => get(state, Actions.namespace, {}));
  const file = get(playoutState, 'currentUploadFile.ref', {});
  /*
    since the import process wasn't done, if we redirect user to Playout History 
    without setPlayoutOverview, Playout History component will get
    all file that store at DB, which didn't include the file we're importing.
    => setPlayoutOverview with a default list value as empty array until
    the import process is done.
  */
  yield put(Actions.setPlayoutOverview([], DEFAULT_RANGE));
  //redirect user to Upload Logs
  yield put(goToPlayoutUploadHistory());
  yield put(Actions.setLoadingStatus(Actions.Status.LOADING));

  //uploading
  if (file) {
    yield put(uploadRequest(
      id,
      file,
      (res) => importLogWithUploadedFile(res, action.payload))
    );
  } else {
    const errorToast = {
      message: 'Uploading file failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
}

function* getPlayoutOverview(action) {
  const { range, getDataOnly } = action.payload;
  const state = yield select();
  const config = state.config;
  const newRange = range && !isEmpty(range) ? range : DEFAULT_RANGE;
  const requestRange = {
    start: convertdateUTC(newRange.start, true),
    end: convertdateUTC(newRange.end, false)
  }
  const isPlayoutEnabled = get(state, 'user.user.organization.kvp.features.attribute.uploadLogs') === "enabled";
  const isWebUploadEnabled = get(state, 'user.user.organization.kvp.features.attribute.webLogUploader') === "enabled";
  const fileTypes = [];
  if (isPlayoutEnabled) {
    fileTypes.push(PLAYOUT_DATA_TYPE);
  }
  if (isWebUploadEnabled) {
    fileTypes.push(WEB_DATA_TYPE);
  }
  yield put(Actions.setLoadingStatus(Actions.Status.LOADING));
  const fetchResults = yield getPlayoutOverviewApi(config.urlApi, requestRange, fileTypes);
  if (fetchResults && !fetchResults.error) {
    const uploadedPlayoutLogs = get(fetchResults, 'data', []);
    const totalRecords = get(fetchResults, 'totalRecords', 0);
    yield put(Actions.setPlayoutOverview(uploadedPlayoutLogs, newRange, totalRecords));
  } else {
    const errorToast = {
      message: 'Get playout overview failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
}

function* getUpdatedPlayoutOverview(action) {
  const state = yield select();
  const config = state.config;
  const range = get(state, 'playout.range', DEFAULT_RANGE);
  const requestRange = {
    start: convertdateUTC(range.start, true),
    end: convertdateUTC(range.end, false)
  }

  const isPlayoutEnabled = get(state, 'user.user.organization.kvp.features.attribute.uploadLogs') === "enabled";
  const isWebUploadEnabled = get(state, 'user.user.organization.kvp.features.attribute.webLogUploader') === "enabled";
  const fileTypes = [];
  if (isPlayoutEnabled) {
    fileTypes.push(PLAYOUT_DATA_TYPE);
  }
  if (isWebUploadEnabled) {
    fileTypes.push(WEB_DATA_TYPE);
  }

  yield put(Actions.setLoadingStatus(Actions.Status.LOADING));
  const fetchResults = yield getPlayoutOverviewApi(config.urlApi, requestRange, fileTypes);
  if (fetchResults && !fetchResults.error) {
    const uploadedPlayoutLogs = get(fetchResults, 'data', []);
    const totalRecords = get(fetchResults, 'totalRecords', 0);
    yield put(Actions.setPlayoutOverview(uploadedPlayoutLogs, undefined, totalRecords));
  } else {
    const errorToast = {
      message: 'Get playout overview failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
}

function* savePlayoutSetting(action) {
  const { settings } = action.payload;
  const config = yield select(state => state.config);
  yield put(Actions.setPlayoutSettingStatus(Actions.Status.LOADING));
  const fetchResults = yield savePlayoutSettingApi(config.urlApi, settings);
  if (fetchResults && !fetchResults.error) {
    const setting = get(fetchResults, 'data', {});
    yield put(Actions.setPlayoutSetting(setting));
  } else {
    const errorToast = {
      message: 'Save playout setting failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
}

function* getPlayoutSetting() {
  const config = yield select(state => state.config);
  yield put(Actions.setPlayoutSettingStatus(Actions.Status.LOADING));
  const fetchResults = yield getPlayoutSettingApi(config.urlApi);
  if (fetchResults && !fetchResults.error) {
    const setting = get(fetchResults, 'data', {});
    yield put(Actions.setPlayoutSetting(setting));
  } else {
    const errorToast = {
      message: 'Get playout setting failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
}

function* updateImportStatus(action) {
  const { statusInfo } = action.payload;
  const config = yield select(state => state.config);
  yield put(Actions.setLoadingStatus(Actions.Status.LOADING));
  const fetchResults = yield updateImportStatusApi(config.urlApi, statusInfo);
  if (fetchResults && !fetchResults.error) {
    const overviewInfo = get(fetchResults, 'data', {});
    yield put(Actions.setPlayoutOverview(overviewInfo));
  } else {
    const errorToast = {
      message: 'Update import status failed',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
}

function* getPlayoutStationsSaga(action) {
  const { stationIds = [] } = action.payload;
  const urlApi = yield select(state => get(state, 'config.urlApi'));

  //handle Attribute station
  const attributeStationsResult = yield getStationAvailabilityApi(urlApi, stationIds);

  //handle Veritone station
  const stationState = yield select(state => get(state, stationNamespace, {}));
  const { data: stationData, status: stationLoadedStatus } = stationState;
  let veritoneStations;
  if (stationLoadedStatus === stationStatus.LOADED) {
    veritoneStations = stationData;
  } else {
    const stationResult = yield call(getStationSaga, getStation());
    veritoneStations = get(stationResult, 'data', stationResult);
  }

  //handle error
  if (attributeStationsResult.error || veritoneStations.error) {
    const errorToast = {
      message: "Get stations fail",
      action: "Dismiss",
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }

  //if no error
  const attributeKnownStations = get(attributeStationsResult, 'data.knownStations', []);
  const veritoneStationCallsignHashmap = veritoneStations.reduce((acc, station) => {
    const stationCallSign = get(station, 'details.stationCallSign');
    const stationBand = get(station, 'details.stationBand');
    const callsign = stationBand ? `${stationCallSign}-${stationBand}` : stationCallSign;
    acc[callsign] = station;
    return acc;
  }, {});

  //calculate unknown station
  //unknown stations: which is unavailable on Veritone or Atribute side
  const unknownStations = stationIds.reduce((acc, item) => {
    if (!veritoneStationCallsignHashmap[item] || !attributeKnownStations.includes(item)) {
      acc[item] = true;
    }
    return acc;
  }, {});
  yield put(Actions.updateCurrentUploadData({
    unknownStations: Object.keys(unknownStations)
  }));
}

function* downloadPlayoutFile(action) {
  const { ref: TDOId, name, fileType } = action.payload;
  const urlApi = yield select(state => get(state, 'config.urlApi', ''));
  const assetTypeLog = fileType === PLAYOUT_DATA_TYPE ? assetPlayoutLogs : assetWebLogs;
  const res = yield getFileUriFromTdoApi(urlApi, TDOId, assetTypeLog);

  let downloadResult;
  if (res && !res.error) {
    const { uri } = res;
    downloadResult = yield downloadFileApi(uri, name);
  }

  if (!downloadResult || downloadResult.error) {
    const toast = {
      message: "Error download file csv!",
      action: "Dismiss",
      type: constants.FAILED
    };
    return yield put(showToast(toast));
  }
}

function* getJobStatusPlayoutSaga(data) {

  const urlApi = yield select(state => get(state, 'config.urlApi', ''));
  const jobDataHashMap = {};
  const jobIds = [];
  data.forEach(item => {
    const { jobId } = item;
    jobDataHashMap[jobId] = item;
    jobIds.push(jobId);
  });

  const jobStatusRes = yield getJobStatusApi(urlApi, jobIds);
  if (!jobStatusRes || jobStatusRes.error) {
    const errorToast = {
      message: 'Get Job Status Fail',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }
  const completedTDOIds = [];
  Object.keys(jobStatusRes).map(item => {
    const statusItem = get(jobStatusRes, [item, 'tasks', 'records', 0, 'status']);
    const jobId = item.replace(JOB_PREFIX, "");
    if (statusItem === PLAYOUT_IMPORT_STATUS.COMPLETED) {
      const { fileReference: TDOId } = jobDataHashMap[jobId];
      completedTDOIds.push(TDOId);
    }
  });
  const errorStatusRes = yield checkErrorStatusPlayoutApi(urlApi, completedTDOIds);

  if (!errorStatusRes || errorStatusRes.error) {
    const errorToast = {
      message: 'Check Error Status Fail',
      action: 'Dismiss',
      type: constants.FAILED
    };
    yield put(showToast(errorToast));
  }

  const dataGetJobStatus = data.map(item => {
    let newStatus;
    let url;
    const { jobId, fileReference: TDOId } = item;
    const TDOIdKey = `${TDO_PREFIX}${TDOId}`;
    const jobIdKey = `${JOB_PREFIX}${jobId}`;
    const statusCheckError = get(errorStatusRes, [`${TDOIdKey}`, 'assets', 'records', '0', 'assetType'], '');
    const statusItem = get(jobStatusRes, [`${jobIdKey}`, 'tasks', 'records', '0', 'status'], null);

    if (statusCheckError === assetPlayoutError) {
      newStatus = PLAYOUT_IMPORT_STATUS.ERROR;
      url = get(errorStatusRes, [`${TDOIdKey}`, 'assets', 'records', '0', 'signedUri'], '');
    } else {
      newStatus = statusItem;
    }
    return {
      ...item,
      status: newStatus,
      errors: { url }
    }
  });
  return dataGetJobStatus;
}


function* getSingedUriPlayoutError(action) {
  const { TDOId } = action.payload;
  const state = yield select();
  const urlApi = get(state, 'config.urlApi');
  yield put(Actions.setLoadingPlayoutErrorStatus(Actions.Status.LOADING));
  const res = yield getSingedUriFromTDOId(urlApi, TDOId);
  const { records } = res;
  if (!res || res.error) {
    yield put(Actions.setLoadingPlayoutErrorStatus(Actions.Status.ERROR));
    const toast = {
      message: "Get Error File Fail",
      action: "Dismiss",
      type: constants.FAILED
    };
    return yield put(showToast(toast));
  } else {
    const errorRecord = records.filter(item => item.assetType === assetWebError ||  item.assetType === assetPlayoutError)[0];
    const uri = get(errorRecord, 'signedUri');
    yield put(Actions.saveSingedUriForPlayoutError(uri));
    yield put(Actions.setLoadingPlayoutErrorStatus(Actions.Status.LOADED));
  }
}

function* downloadErrorReportSaga(action) {
  const { uri, name } = action.payload;
  const res = yield downloadFileApi(uri, name);
  if (!res || res.error) {
    const toast = {
      message: "Download Error Report Fail",
      action: "Dismiss",
      type: constants.FAILED
    };
    return yield put(showToast(toast));
  }
}

export default function* playoutUploader() {
  const ActionType = Actions.ACTION_TYPES;

  yield all([
    takeEvery(ActionType.IMPORT_PLAYOUT_WITH_DATA_MAPPING, importLogsWithDataMappingSaga),
    takeEvery(ActionType.GET_PLAYOUT_DATA_OVERVIEW, getPlayoutOverview),
    takeEvery(ActionType.GET_UPDATED_PLAYOUT_DATA_OVERVIEW, getUpdatedPlayoutOverview),
    takeEvery(ActionType.GET_PLAYOUT_DATA_SETTING, getPlayoutSetting),
    takeEvery(ActionType.SAVE_PLAYOUT_DATA_SETTING, savePlayoutSetting),
    takeEvery(ActionType.UPDATE_IMPORT_STATUS, updateImportStatus),
    takeEvery(ActionType.GET_PLAYOUT_STATIONS, getPlayoutStationsSaga),
    takeEvery(ActionType.DOWNLOAD_PLAYOUT_FILE, downloadPlayoutFile),
    takeEvery(ActionType.GET_JOB_STATUS_PLAYOUT, getJobStatusPlayoutSaga),
    takeEvery(ActionType.GET_SINGED_URI_PLAYOUT_ERROR, getSingedUriPlayoutError),
    takeEvery(ActionType.DOWNLOAD_ERROR_REPORT, downloadErrorReportSaga)
  ])
}